module.exports = __webpack_public_path__ + "img/logo_linkedscreen.1ad53b8e.png";